import { useState, useEffect } from "react";
import fleetApi from "@/lib/fleetApi";
import { Mail, CheckCircle2, Clock } from "lucide-react";

export function DriverOnboardingPanel({ reloadKey }) {
  const [status, setStatus] = useState(null);
  const [invites, setInvites] = useState([]);
  useEffect(() => {
    fleetApi.get("/drivers/onboarding-status").then((r) => setStatus(r.data)).catch(() => setStatus(null));
    fleetApi.get("/invites").then((r) => setInvites((Array.isArray(r.data) ? r.data : []).filter((i) => i.role === "driver" && !i.accepted_at && i.status !== "accepted"))).catch(() => setInvites([]));
  }, [reloadKey]);
  if (!status && !invites.length) return null;
  const rows = status?.drivers || [];
  return (
    <div className="mb-4 rounded-xl border border-slate-800 bg-[#111827] p-4" data-testid="driver-onboarding-panel">
      <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-400">
        Driver onboarding · {status?.completed ?? 0} of {status?.total ?? rows.length} done{invites.length ? ` · ${invites.length} invite${invites.length === 1 ? "" : "s"} pending` : ""}
      </p>
      <ul className="flex flex-wrap gap-2">
        {invites.map((i) => (
          <li key={i.id} className="inline-flex items-center gap-1.5 rounded-full border border-blue-500/40 bg-blue-500/10 px-3 py-1 text-xs text-blue-200" data-testid={`onboarding-invite-${i.id}`}>
            <Mail className="h-3 w-3" /> {i.full_name || i.email} · Invite sent · <span className="font-mono-data font-semibold">{i.code}</span>
          </li>
        ))}
        {rows.filter((d) => !d.onboarded).map((d) => (
          <li key={d.driver_id} className="inline-flex items-center gap-1.5 rounded-full border border-amber-500/40 bg-amber-500/10 px-3 py-1 text-xs text-amber-200" data-testid={`onboarding-pending-${d.driver_id}`}>
            <Clock className="h-3 w-3" /> {d.name} · {d.invite_code ? <>Invite sent · <span className="font-mono-data font-semibold">{d.invite_code}</span></> : "hasn't finished setup"}
          </li>
        ))}
        {rows.filter((d) => d.onboarded).slice(0, 6).map((d) => (
          <li key={d.driver_id} className="inline-flex items-center gap-1.5 rounded-full border border-emerald-500/30 bg-emerald-500/10 px-3 py-1 text-xs text-emerald-200"><CheckCircle2 className="h-3 w-3" /> {d.name}</li>
        ))}
      </ul>
    </div>
  );
}
